export type HotkeyGroup = 'status' | 'actions' | 'navigation';

export interface HotkeyDef {
  sequence: string;      // react-hotkeys-hook format e.g. "ctrl+k n"
  label: string;         // human-readable e.g. "Ctrl+K → N"
  descriptionKey: string; // i18n key; cross-namespace prefix supported (e.g. "findings:statuses.new")
  group: HotkeyGroup;
  pages: ('list' | 'detail')[];
}

export const STATUS_HOTKEYS: HotkeyDef[] = [
  { sequence: 'ctrl+k>n', label: 'Ctrl+K → N', descriptionKey: 'findings:statuses.new',            group: 'status', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>c', label: 'Ctrl+K → C', descriptionKey: 'findings:statuses.confirmed',      group: 'status', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>i', label: 'Ctrl+K → I', descriptionKey: 'findings:statuses.in_progress',    group: 'status', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>f', label: 'Ctrl+K → F', descriptionKey: 'findings:statuses.false_positive', group: 'status', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>x', label: 'Ctrl+K → X', descriptionKey: 'findings:statuses.fixed',          group: 'status', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>r', label: 'Ctrl+K → R', descriptionKey: 'findings:statuses.risk_accepted',  group: 'status', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>w', label: 'Ctrl+K → W', descriptionKey: 'findings:statuses.wont_fix',       group: 'status', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>e', label: 'Ctrl+K → E', descriptionKey: 'findings:statuses.renewed',        group: 'status', pages: ['list', 'detail'] },
];

export const ACTION_HOTKEYS: HotkeyDef[] = [
  { sequence: 'ctrl+k>j', label: 'Ctrl+K → J', descriptionKey: 'hotkeys.descriptions.createJira',    group: 'actions', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>g', label: 'Ctrl+K → G', descriptionKey: 'hotkeys.descriptions.groupSelected', group: 'actions', pages: ['list'] },
  { sequence: 'ctrl+k>d', label: 'Ctrl+K → D', descriptionKey: 'hotkeys.descriptions.delete',                  group: 'actions', pages: ['list', 'detail'] },
  { sequence: 'ctrl+k>m', label: 'Ctrl+K → M', descriptionKey: 'hotkeys.descriptions.goToComments',  group: 'actions', pages: ['detail'] },
];

export const NAV_HOTKEYS: HotkeyDef[] = [
  { sequence: 'j',      label: 'J',     descriptionKey: 'hotkeys.descriptions.nextFinding',   group: 'navigation', pages: ['list'] },
  { sequence: 'k',      label: 'K',     descriptionKey: 'hotkeys.descriptions.prevFinding',  group: 'navigation', pages: ['list'] },
  { sequence: 'enter',  label: 'Enter', descriptionKey: 'hotkeys.descriptions.openFinding',     group: 'navigation', pages: ['list'] },
  { sequence: 'escape', label: 'Esc',   descriptionKey: 'hotkeys.descriptions.clearSelection',     group: 'navigation', pages: ['list'] },
  { sequence: 'f1',     label: 'F1',    descriptionKey: 'hotkeys.descriptions.help',  group: 'navigation', pages: ['list', 'detail'] },
];

export const ALL_HOTKEYS: HotkeyDef[] = [
  ...STATUS_HOTKEYS,
  ...ACTION_HOTKEYS,
  ...NAV_HOTKEYS,
];

// Status value keyed by sequence letter (for building useHotkeys calls)
export const STATUS_SEQUENCE_MAP: Record<string, string> = {
  n: 'new',
  c: 'confirmed',
  i: 'in_progress',
  f: 'false_positive',
  x: 'fixed',
  r: 'risk_accepted',
  w: 'wont_fix',
  e: 'renewed',
};
